import React from 'react';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { SideDrawerContentContainer } from '../../../../../v2BaseComponents/SideDrawer';
import InvitationDetails from '../../../../../shared/OrganizationInvitations/OrganizationInvitationDetails';
import useOrganizationUserInvitations from '../../../../../../hooks/api/useOrganizationUserInvitations';

export type InvitationDetailsDrawerContentOwnProps = {
    InvitationId: string;
};

export type InvitationDetailsDrawerContentProps = InvitationDetailsDrawerContentOwnProps;

const InvitationDetailsDrawerContent: React.FC<InvitationDetailsDrawerContentProps> = ({ InvitationId }) => {
    const { isLoadingInvitation, invitation } = useOrganizationUserInvitations({
        invitationId: InvitationId,
    });

    return (
        <AnimateLoadedContent isLoading={isLoadingInvitation || !invitation}>
            {() => (
                <SideDrawerContentContainer>
                    <InvitationDetails invitation={invitation!} />
                </SideDrawerContentContainer>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(InvitationDetailsDrawerContent);
